export const INDEX = 'THREAD_INDEX'
export const THREADS = 'THREAD_THREADS'
export const ON_CHANGE = 'THREAD_ON_CHANGE'
export const LOADING = 'THREAD_LOADING'
